import {Injectable} from '@angular/core'
import {Headers} from '@angular/http'

@Injectable()
export class HeadersService {
    constructor() { }

    getJsonHeaders(token?: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'q=0.8;application/json;q=0.9');

        if (token){
            // headers.append('x-access-token', token)
            headers.append('Authorization', token);
        }
        
        return { headers: headers };
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/header/header.service.ts
 **/